module.exports = __webpack_public_path__ + "img/爱莫科技.2327a6e6.png";